import { render } from "./DriverRecruitTitle.vue?vue&type=template&id=44c31faa&scoped=true"
import script from "./DriverRecruitTitle.vue?vue&type=script&lang=js"
export * from "./DriverRecruitTitle.vue?vue&type=script&lang=js"

import "./DriverRecruitTitle.vue?vue&type=style&index=0&id=44c31faa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c31faa"]])

export default __exports__